/**
 * build the SSO login url, and does not preserve the query parameters of the current URL
 * @param baseUrl - of the SSO login URL
 * @param returnUrl - where to return to after SSO login is complete
 * @param rememberMe - whether or not to remember the user
 * @param showRememberMe - whether or not to include remember me as a query parameter for the state
 * @returns {string} - the SSO login URL, along with the return URL and its query parameters
 */
const buildSsoLoginUrl = (baseUrl, returnUrl, rememberMe, showRememberMe) => {
    if (!baseUrl) {
        return '';
    }

    const param = showRememberMe
        ? { remember_me: rememberMe, return_url: returnUrl }
        : { return_url: returnUrl };

    const stateQueryParam = encodeURIComponent(JSON.stringify(param));

    const questionMarkIndex = baseUrl.indexOf('?');
    const queryString = baseUrl.slice(questionMarkIndex + 1);

    if (questionMarkIndex === -1) {
        return `${baseUrl}?state=${stateQueryParam}`;
    } else if (queryString) {
        return `${baseUrl}&state=${stateQueryParam}`;
    } else {
        return `${baseUrl}state=${stateQueryParam}`;
    }
};

export { buildSsoLoginUrl };
